import i18n, { InitOptions } from 'i18next';
import { HMRPlugin } from 'i18next-hmr/plugin';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const backendOptions: InitOptions<HttpBackendOptions> = {
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  react: {
    useSuspense: false,
  },
  ns: ['translation', 'toast', 'global', 'nav', 'admin', 'enum'],
  defaultNS: 'translation',
  debug: false,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
};

export const initI18n = () => {
  if (i18n.isInitialized) {
    return i18n;
  }

  i18n.use(Backend);

  if (import.meta.env.MODE !== 'production') {
    i18n.use(new HMRPlugin({ vite: { client: true } }));
  }

  void i18n
    .use(initReactI18next)
    .init<HttpBackendOptions>(backendOptions)
    .catch((error) => {
      console.error('i18n initialization failed', error);
    });

  return i18n;
};

initI18n();
export default i18n;
